import { render } from "./PlayerStatisticsGraph.vue?vue&type=template&id=72b714a6"
import script from "./PlayerStatisticsGraph.vue?vue&type=script&lang=js"
export * from "./PlayerStatisticsGraph.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__